import React, { createContext, useContext, useState } from "react";

const AlertContext = createContext({ showAlert: () => {} });

export function AlertProvider({ children }) {
  const [message, setMessage] = useState(null);

  const showAlert = (msg) => setMessage(msg);
  const hideAlert = () => setMessage(null);

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {message && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white p-6 rounded shadow-lg text-center max-w-sm">
            <p className="mb-4">{message}</p>
            <button
              onClick={hideAlert}
              className="px-4 py-2 bg-blue-600 text-white rounded"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </AlertContext.Provider>
  );
}

export function useAlert() {
  return useContext(AlertContext);
}

